import { render, staticRenderFns } from "./entity-card-bank-statements-overview.vue?vue&type=template&id=ef743822&scoped=true&"
import script from "./entity-card-bank-statements-overview.vue?vue&type=script&lang=js&"
export * from "./entity-card-bank-statements-overview.vue?vue&type=script&lang=js&"
import style0 from "./entity-card-bank-statements-overview.vue?vue&type=style&index=0&id=ef743822&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef743822",
  null
  
)

export default component.exports